import React from 'react';
import { toastSubject, Toast } from '../../subjects/GlobalSubjects';
import './Toast.css';

const ToastComponent: React.FC = () => {
    const [toast, setToast] = React.useState<Toast | null>(null);

    React.useEffect(() => {
        const subscription = toastSubject.subscribe((toast) => {
            setToast(toast);
            if (toast == null) {
                return;
            }
            setTimeout(() => {
                toastSubject.next(null);
            }, 5000);
        });

        return () => {
            console.log('Unsubscribing from toastSubject');
            subscription.unsubscribe()
        };
    }, [toastSubject]);

    return (
        <div className={`toast ${toast == null ? '' : 'show'} ${toast?.type ?? ''}`}>
            {toast?.message}
        </div>
    );
};

export default ToastComponent;